import React from 'react';

const causeColors = {
    BB_STATUS: 'bg-purple-100 text-purple-800',
    LOST_BB: 'bg-red-100 text-red-800',
    OVERPRICED: 'bg-orange-100 text-orange-800',
    DEAD_STOCK: 'bg-gray-100 text-gray-800',
    SLOW_MOVING: 'bg-yellow-100 text-yellow-800',
};

export default function ExcessInventory({ data }) {
    if (!data || data.length === 0) {
        return <p className="text-gray-500 py-4">No excess inventory issues found.</p>;
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Avail</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Excess</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Sell-Through</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Storage/Mo</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Aged Fees</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Our Price</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Lowest</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Root Cause</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Action</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item, idx) => (
                        <tr key={idx} className="hover:bg-gray-50">
                            <td className="px-3 py-3 text-sm">
                                <div className="font-medium text-gray-900 truncate max-w-[200px]" title={item.productName}>
                                    {item.productName}
                                </div>
                                <div className="text-xs text-gray-400">{item.asin}</div>
                            </td>
                            <td className="px-3 py-3 text-sm text-right">{item.available}</td>
                            <td className="px-3 py-3 text-sm text-right font-medium text-red-600">{item.estimatedExcessQty}</td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.sellThrough != null ? Number(item.sellThrough).toFixed(2) : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.estimatedStorageCostNextMonth != null ? `$${Number(item.estimatedStorageCostNextMonth).toFixed(2)}` : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.agedInventoryFees != null && Number(item.agedInventoryFees) > 0
                                    ? `$${Number(item.agedInventoryFees).toFixed(2)}`
                                    : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.ourPrice != null ? `$${Number(item.ourPrice).toFixed(2)}` : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.lowestPrice != null ? `$${Number(item.lowestPrice).toFixed(2)}` : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm">
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${causeColors[item.rootCause] || 'bg-gray-100 text-gray-600'}`}>
                                    {item.rootCause?.replace('_', ' ')}
                                </span>
                            </td>
                            <td className="px-3 py-3 text-sm text-gray-600 max-w-[180px]">{item.suggestedAction}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
